import { FluentBundle } from "fluent";
import { GetString } from "fluent-react";
import React, { RefObject } from "react";
import styled from "styled-components";
import CountryProfilesLanguageProvider from "../../contextProviders/CountryProfilesLanguageProvider";
import { menuBaseColor } from "../../cssVariables";
import { SlideElementProps } from "../../presentationManager/PresentationManager";
import Nav from "../../sharedComponents/NewNav";
import CountrySelector from "../countrySelector/LandingPageCountrySelector";
import BottomNav from "../landingBottomNav";
import Widgets from "../landingPageInfoWidgets";
import Map from "../map";
import {
  Grid,
  HeaderContainer,
  LeftPanelContainer as LeftPanelContainerBase,
} from "./Grid";
import Text from "./Text";
import TutorialVideoButton from "./TutorialVideoButton";

//#region Styling
const localZIndices = {
  header: 30,
};

const Root = styled(Grid)`
  overflow: auto;
  padding: 0 5%;
`;
const LeftPanelContainer = styled(LeftPanelContainerBase)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const NavContainer = styled(HeaderContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3.75rem;
  position: relative;
  z-index: ${localZIndices.header};
`;
const AtlasLogoImageContainer = styled.a`
  display: block;
`;
const AtlasLogoImage = styled.img`
  position: relative;
  top: 3px;
  height: 40px;
  min-height: 45px;
`;
//#endregion

interface Props extends SlideElementProps {
  rootZIndex: number;
  getFluentString: GetString;
  countryId: string;
  selectCountry: (country: string) => void;
  fluentBundle: FluentBundle;
  setSlideIndex: (index: number) => void;
  year: number;
}
const leftPanelZIndices = {
  dropdown: 20,
  text: 10,
};

const MainContent = React.forwardRef(
  (props: Props, rootElRef: RefObject<HTMLDivElement>) => {
    const {
      rootZIndex,
      getFluentString,
      countryId,
      selectCountry,
      fluentBundle,
      setSlideIndex,
      year,
    } = props;
    const style: React.CSSProperties = {
      zIndex: rootZIndex,
    };

    return (
      <CountryProfilesLanguageProvider>
        <Root style={style} ref={rootElRef}>
          <NavContainer>
            <AtlasLogoImageContainer href="/">
            <AtlasLogoImage src={require('../../img/logo-updates-2023/GL_logo_black.png')}/>
            </AtlasLogoImageContainer>
            <Nav normalTextColor="white" highlightColor={menuBaseColor} />
          </NavContainer>
          <LeftPanelContainer>
            <CountrySelector
              selectedCountry={countryId}
              onCountrySelect={selectCountry}
              promptText={getFluentString("country-selector-prompt")}
              getFluentString={getFluentString}
              zIndex={leftPanelZIndices.dropdown}
            />
            <Text
              countryId={countryId}
              getFluentString={getFluentString}
              fluentBundle={fluentBundle}
              zIndex={leftPanelZIndices.text}
              year={year}
            />
          </LeftPanelContainer>
          <Widgets countryId={countryId} getFluentString={getFluentString} />
          <Map countryId={countryId} selectCountry={selectCountry} />
          <BottomNav
            onIconClick={setSlideIndex}
            getFluentString={getFluentString}
          />
          <TutorialVideoButton getFluentString={getFluentString} />
        </Root>
      </CountryProfilesLanguageProvider>
    );
  }
);

export default MainContent;
